// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/766d6ae4ed17f7909c9d.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"93e80029d10167c06fa6","179":"3498a4d6bcedde379fea","180":"80304eba6948f33901b6"}[chunkId] + ".chunk.js";
};